/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import ListMultiSelectionPane from 'core/component/ListMultiSelectPane'
import R from 'ramda'
import { Checkbox } from 'antd'

const ActionPane = ({ contentHeightOffset, actions, selectedIds, setSelectedIds }) => {
  return (
    <ListMultiSelectionPane
      data={actions}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      contentHeightOffset={contentHeightOffset}
      toId={a => a.id}
      acceptFilter={action => fuzzyFilter =>
        ` ${action.id} ${action.displayName} ${action.category} ${action.description}`
          .toLowerCase()
          .includes(fuzzyFilter.toLowerCase())}
      renderContent={({ data, toggleId, selectedIds }) => {
        const groupedData = R.groupBy(a => a.category, data)
        const sortedCats = Object.keys(groupedData).sort((a, b) =>
          a.toLowerCase().localeCompare(b.toLowerCase())
        )

        return R.chain(
          c => [
            <div
              css={{
                fontSize: '1.3em',
                paddingBottom: '2px',
                marginBottom: '5px',
                marginTop: '10px',
                borderBottom: '1px solid #f2f2f2',
                textTransform: 'capitalize',
              }}
              key={'cat-' + c}
            >
              {c}
            </div>,
            ...R.sortBy(R.compose(R.toLower, R.prop('displayName')))(groupedData[c]).map(item => (
              <div key={item.id} css={{ marginLeft: '16px' }}>
                <Checkbox checked={selectedIds.includes(item.id)} onClick={() => toggleId(item.id)}>
                  {item.displayName}
                  {item.description !== item.displayName && (
                    <span
                      css={{
                        marginLeft: '10px',
                        fontSize: '.8em',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.description}
                    </span>
                  )}
                </Checkbox>
              </div>
            )),
          ],
          sortedCats
        )
      }}
    />
  )
}

export default ActionPane
